var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25589_19064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C17.523 2.5 22 6.977 22 12.5C22 18.023 17.523 22.5 12 22.5C6.477 22.5 2 18.023 2 12.5C2 6.977 6.477 2.5 12 2.5ZM9.879 8.964C9.69946 8.78275 9.45743 8.67697 9.20245 8.66832C8.94748 8.65967 8.69883 8.7488 8.50742 8.91747C8.31601 9.08613 8.1963 9.32159 8.1728 9.57562C8.14929 9.82966 8.22378 10.0831 8.381 10.284L8.465 10.379L10.585 12.499L8.465 14.621C8.28375 14.8005 8.17797 15.0426 8.16932 15.2975C8.16067 15.5525 8.2498 15.8012 8.41847 15.9926C8.58713 16.184 8.82258 16.3037 9.07662 16.3272C9.33066 16.3507 9.58408 16.2762 9.785 16.119L9.879 16.036L12 13.914L14.121 16.036C14.3005 16.2173 14.5426 16.323 14.7975 16.3317C15.0525 16.3403 15.3012 16.2512 15.4926 16.0825C15.684 15.9139 15.8037 15.6784 15.8272 15.4244C15.8507 15.1703 15.7762 14.9169 15.619 14.716L15.536 14.621L13.414 12.5L15.536 10.379C15.7173 10.1995 15.823 9.95743 15.8317 9.70245C15.8403 9.44748 15.7512 9.19883 15.5825 9.00742C15.4139 8.81601 15.1784 8.6963 14.9244 8.6728C14.6703 8.64929 14.4169 8.72378 14.216 8.881L14.121 8.964L12 11.086L9.879 8.964Z",
    fill: "#FF3F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25589_19064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessage);
export default __webpack_public_path__ + "static/media/error-message.6fd8970dab5a10a779152b4a592e8e5a.svg";
export { ForwardRef as ReactComponent };